import { CreateSpecialtyGroupException } from "@app/exceptions/interfaces";
import { NetworkSubmissionProject, NetworkSubmissionWizardStep } from "@app/compliance-connect/network-submission/interfaces";

export interface NetworkSubmissionWizardState {
  comments: string;
  emailSharedUsers: boolean;
  isConfirmed: boolean;
  isCurrentStepValid: boolean;
  page: NetworkSubmissionWizardStep;
  pendingExceptions: Map<string, CreateSpecialtyGroupException>;
  regulatorClientId: number | null;
  selectedProject: NetworkSubmissionProject | null;
  sharedUserIds: number[];
  submissionDescription: string;
  submissionName: string;
}

export const networkSubmissionWizardInitialState: NetworkSubmissionWizardState = Object.freeze({
  comments: "",
  emailSharedUsers: true,
  isConfirmed: false,
  isCurrentStepValid: false,
  page: NetworkSubmissionWizardStep.SelectRegulator,
  pendingExceptions: new Map<string, CreateSpecialtyGroupException>(),
  regulatorClientId: null,
  selectedProject: null,
  sharedUserIds: [],
  submissionDescription: "",
  submissionName: "",
});
